import { MediaDevices } from '@wix/package-picker-common';
import * as React from 'react';
import { getContentByScenario } from './getContentByScenario';
import { useComponentsTranslations, useBreakpoint } from '../../../providers';
import { SidedIconTrustBuilder } from '../SidedIconTrustBuilder';
export const MoneyBackGuarantee = (props) => {
    const { iconClass, descKey, titleKey } = getContentByScenario(props);
    const { t } = useComponentsTranslations();
    const { currentBreakpoint } = useBreakpoint();
    return (React.createElement(SidedIconTrustBuilder, { title: t(titleKey[currentBreakpoint ?? MediaDevices.Desktop]), description: t(descKey), icon: React.createElement("i", { className: iconClass }) }));
};
//# sourceMappingURL=MoneyBackGuarantee.js.map